// Integrations
export const TENANT_ADMIN_INTEGRATIONS_ROUTE = {
    path: 'integrations',
    fullPath: '/tenant-admin/integrations',
} as const;

// Organization Management
export const TENANT_ADMIN_ORGANIZATION_MANAGEMENT_ROUTE = {
    path: 'organizations',
    fullPath: '/tenant-admin/organizations',
} as const;

// SSO Configuration
export const TENANT_ADMIN_SSO_CONFIGURATION_ROUTE = {
    path: 'sso-configuration',
    fullPath: '/tenant-admin/sso-configuration',
} as const;

// Terminology
export const TENANT_ADMIN_TERMINOLOGY_ROUTE = {
    path: 'terminology',
    fullPath: '/tenant-admin/terminology',
} as const;

// User Management
export const TENANT_ADMIN_USER_MANAGEMENT_ROUTE = {
    path: 'user-management',
    fullPath: '/tenant-admin/user-management',
} as const;

export const TENANT_ADMIN_EDIT_USER_ROUTE = {
    path: 'edit/$userId',
    fullPath: '/tenant-admin/user-management/edit/$userId',
} as const;

export const TENANT_ADMIN_CREATE_USER_ROUTE = {
    path: 'create',
    fullPath: '/tenant-admin/user-management/create',
} as const;
